
import { Component, Vue} from 'vue-property-decorator';
import NavigationTopbar from "./components/NavigationTopbar.vue";
import NavigationFooter from "./components/NavigationFooter.vue";

@Component({
    components: {
        NavigationTopbar,
        NavigationFooter
    }
})

export default class App extends Vue {

}
